import type { NotificationArgsProps } from 'antd';
type NotificationPlacement = NotificationArgsProps['placement'];

interface setNotificationsProps {
  success: (args: NotificationArgsProps) => void;
  error: (args: NotificationArgsProps) => void;
}

const setNotifications = (api: setNotificationsProps) => {
  const openNotification = (message: string, title: string) => {
    if (title === 'Success') {
      api.success({
        message: title,
        description: message,
        placement: 'topRight' as NotificationPlacement,
      });
    } else if (title === 'Error') {
      api.error({
        message: title,
        description: message,
        placement: 'topRight' as NotificationPlacement,
      });
    }
  };

  return openNotification;
};

export default setNotifications;
